import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

/**
 * Check if current path is any dashboard route
 */
export const isDashboardRoute = (pathname: string): boolean => {
	return (
		pathname.startsWith(RoutesHelper.getAccessibilityDashboardPath()) ||
		pathname.startsWith(RoutesHelper.getBusinessUnitDashboardPath())
	);
};

/**
 * Check if current path is business units route
 */
export const isBusinessUnitsRoute = (pathname: string): boolean => {
	return pathname.startsWith(RoutesHelper.getBusinessUnitDashboardPath());
};

/**
 * Extract unit ID from business units path (handles both WFA and mobile dashboard paths)
 */
export const extractUnitIdFromPath = (pathname: string): string | null => {
	const knownBasePaths = [
		RoutesHelper.getMobileBusinessUnitDashboardPath(),
		RoutesHelper.getBusinessUnitDashboardPath()
	];

	const matchingBase = knownBasePaths.find((p) => pathname.startsWith(p));
	if (!matchingBase) {
		return null;
	}

	const unitId = pathname.replace(matchingBase, '').replace(/^\/+/, '').replace(/\/+$/, '');
	return unitId || null;
};
